const getCdnConfigArray = () => {
  const str = process.env.ASSETS_CDN || process.env.NEXT_PUBLIC_ASSETS_CDN || "";
  const arr = str ? JSON.parse(str) || [] : [];
  return arr;
};
const getReplaceUrlList = () => {
  const cdnConfig = getCdnConfigArray();
  return cdnConfig.map((item) => item.currentCdnHost);
};
const getHost = (url) => {
  var _a;
  if (typeof url !== "string") {
    console.log("url is not string");
  }
  const restOfUrl = (_a = url.split("//")) == null ? void 0 : _a[1];
  const [host] = restOfUrl.split("/");
  return host;
};
const replaceHost = (oldUrl, newHost) => {
  const url = new URL(oldUrl);
  url.host = newHost;
  let urlString = url.href;
  urlString = urlString.replace(/%20/g, " ");
  return urlString;
};
const checkDomainSwitchNecessity = (sourceUrl) => {
  const host = getHost(sourceUrl);
  const replaceUrlList = getReplaceUrlList();
  const needSwitchDomain = replaceUrlList.includes(host);
  return needSwitchDomain;
};
const getNewHost = (originalHost, cdnSwitchMap) => {
  if (!cdnSwitchMap)
    return originalHost;
  try {
    const config = cdnSwitchMap;
    const cdnConfig = getCdnConfigArray();
    const index = cdnConfig.findIndex((key) => key.currentCdnHost === originalHost);
    if (index > -1) {
      const thisDomainConfig = cdnConfig == null ? void 0 : cdnConfig[index];
      const targetDomainIndex = config == null ? void 0 : config[index];
      const targetDomain = thisDomainConfig.cdnReplacements[targetDomainIndex];
      return targetDomain.replacementHost || originalHost;
    }
    return originalHost;
  } catch (error) {
    console.error("CroppedImage getNewHost error", error);
    return originalHost;
  }
};
const switchDomain = (sourceUrl, cdnSwitchMap) => {
  if (!sourceUrl || typeof sourceUrl !== "string" || !(sourceUrl == null ? void 0 : sourceUrl.startsWith("https://"))) {
    console.log("switchDomain error: sourceUrl is empty or is not string", sourceUrl);
    return sourceUrl;
  }
  if (!cdnSwitchMap || !Object.keys(cdnSwitchMap).length) {
    return sourceUrl;
  }
  const needSwitchDomain = checkDomainSwitchNecessity(sourceUrl);
  if (!needSwitchDomain)
    return sourceUrl;
  const host = getHost(sourceUrl);
  const newHost = getNewHost(host, cdnSwitchMap);
  if (!newHost)
    return sourceUrl;
  return replaceHost(sourceUrl, newHost);
};
export {
  switchDomain as default
};
//# sourceMappingURL=switchDomain-v2.js.map
